import React, { Component } from 'react';
import "../modal/modal.css"

class CloseButton extends Component{
    render() {
        return (
            <div style={this.props?.style ?? {}} onClick={ e => {this.props.onClose(e);}} className={"modalCloseButton blueCircleBackground"}>
                <i className="icoFont">&#xeee1;</i>
            </div>
        );
    }
}

export default CloseButton;
